import { Link } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";

export function TMSLessonHeader({ lesson, actTitle, moduleTitle, progressPct }) {
  return (
    <div data-testid="tms-lesson-header" className="bg-background/95 border-b border-primary/15 px-4 md:px-8 py-5">
      <div className="max-w-[1100px] mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <img src="/tms/seal.png" alt="" className="w-9 h-9 rounded-full object-cover border border-primary/20 shrink-0" />
          <div className="min-w-0">
            <p className="font-meta text-[10px] md:text-xs text-textSecondary uppercase tracking-[0.2em] truncate">
              {actTitle} {moduleTitle ? `· ${moduleTitle}` : ""}
            </p>
            <h1 data-testid="tms-lesson-title" className="font-display text-base md:text-lg text-primary tracking-tight line-clamp-2 md:truncate">
              {lesson.title}
            </h1>
          </div>
        </div>
        <div className="flex items-center gap-4 shrink-0">
          {lesson.canon_duration_min ? (
            <span className="hidden sm:flex items-center gap-1.5 font-meta text-xs text-textSecondary">
              <Clock className="w-3.5 h-3.5" /> {lesson.canon_duration_min} min
            </span>
          ) : null}
          {progressPct != null && (
            <span data-testid="tms-lesson-progress-badge" className="font-meta text-[11px] uppercase tracking-wide text-primary border border-primary/30 px-2.5 py-1">
              {progressPct}% through the curriculum
            </span>
          )}
          <Link to="/themuscleschool" data-testid="tms-lesson-back-link" className="hidden md:flex items-center gap-1.5 font-meta text-xs uppercase tracking-widest text-textSecondary hover:text-primary transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> Curriculum
          </Link>
        </div>
      </div>
    </div>
  );
}
